import axios from "axios";
//import LocalStorageService from "./services/storage/localstorageservice";
import router from "../router";
var parse = require("json-parse-safe");

import Vue from "vue";

let lastAssociationBlockedNotice = 0;
let refreshTokenPromise: Promise<any> | null = null;

const runtimeVariables = (window as any).variables || {};
const runtimeApiBaseUrl = runtimeVariables.API_BASE_URL;
const resolvedRuntimeApiBaseUrl =
  runtimeApiBaseUrl && !String(runtimeApiBaseUrl).includes("${")
    ? String(runtimeApiBaseUrl)
    : "";

const resolveApiBaseUrl = () => {
  const configuredUrl =
    resolvedRuntimeApiBaseUrl ||
    process.env.VUE_APP_API_URL ||
    process.env.API_BASE_URL;
  const apiPort = process.env.VUE_APP_API_PORT || "3334";
  const isBrowser = typeof window !== "undefined" && window.location;

  if (!isBrowser) return configuredUrl || "http://127.0.0.1:3334";

  const hostname = window.location.hostname;
  const isRemoteBrowser = hostname !== "127.0.0.1" && hostname !== "localhost";
  const pointsToLoopback = configuredUrl && /\/\/(127\.0\.0\.1|localhost)(:|\/|$)/.test(configuredUrl);

  if (!configuredUrl || (isRemoteBrowser && pointsToLoopback)) {
    return `${window.location.protocol}//${hostname}:${apiPort}`;
  }

  return configuredUrl;
};

axios.defaults.baseURL = resolveApiBaseUrl();
// axios.defaults.baseURL = "https://seal-app-afrfw.ondigitalocean.app/";
// axios.defaults.baseURL = "https://inoc-backend-api-8467f10d17ce.herokuapp.com/";
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    const data = localStorage.getItem("token");

    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }

    if (data) {
      const parsedToken = parse(data);

      if (parsedToken.value) {
        const { token } = parsedToken.value;

        config.headers["Authorization"] = "Bearer " + token;
      }
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

const extractApiError = (payload: any) => {
  if (!payload) return null;
  if (payload.content && payload.content.error) return payload.content.error;
  if (payload.error) return payload.error;
  return null;
};

const normalizeApiErrorMessage = (apiError: any) => {
  const code = String(apiError && apiError.code ? apiError.code : "");
  let message = String(apiError && apiError.message ? apiError.message : "");

  if (code === "ASSOCIATION_ACCESS_BLOCKED") {
    return "A Associação não está em dia com o BOARUA. O uso da plataforma será liberado após a confirmação do pagamento do plano.";
  }

  if (code && message.indexOf(`${code}: `) === 0) {
    message = message.slice(code.length + 2);
  }

  return message;
};

const notifyApiBusinessError = (payload: any) => {
  const apiError = extractApiError(payload);
  if (!apiError) return;

  const code = String(apiError.code || "");
  if (code !== "ASSOCIATION_ACCESS_BLOCKED") return;

  const now = Date.now();
  if (now - lastAssociationBlockedNotice < 2500) return;
  lastAssociationBlockedNotice = now;

  window.dispatchEvent(new CustomEvent("boarua-api-error", {
    detail: {
      code,
      message: normalizeApiErrorMessage(apiError),
    },
  }));
};

const isAuthEndpoint = (url: string) => {
  return url.includes("/sessions");
};

const redirectToLogin = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("profilePermissions");

  if (router.currentRoute.path !== "/login") {
    router.push("/login").catch(() => {});
  }
};

const refreshSessionToken = async () => {
  if (refreshTokenPromise) return refreshTokenPromise;

  refreshTokenPromise = (async () => {
    const tokenRaw = localStorage.getItem("token");
    if (!tokenRaw) throw new Error("Missing token");

    const parsedToken = parse(tokenRaw);
    if (!parsedToken.value) throw new Error("Invalid token payload");

    const { refreshToken } = parsedToken.value;
    if (!refreshToken) throw new Error("Missing refresh token");

    const res = await axios.post("/sessions/refresh", { refreshToken });
    const content = res && res.data && res.data.content;
    if (!content || !content.token) throw new Error("Invalid refresh response");

    localStorage.setItem("token", JSON.stringify(content));
    axios.defaults.headers.common["Authorization"] = "Bearer " + content.token;
    return content.token;
  })();

  try {
    return await refreshTokenPromise;
  } finally {
    refreshTokenPromise = null;
  }
};

//Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.content && response.data.content.success === false) {
      notifyApiBusinessError(response.data);
      return Promise.reject(response.data);
    }

    if (response.data && response.data.success === false) {
      notifyApiBusinessError(response.data);
      return Promise.reject(response.data);
    }

    return response;
  },
  async function (error) {
    const originalRequest = error.config || {};
    const originalUrl = String(originalRequest.url || "");

    if (error.request && error.request.status == 0) {
      return Promise.reject(error);
    }

    const shouldTryRefresh =
      error.response &&
      [401, 419].includes(error.response.status) &&
      !originalRequest._retry &&
      !isAuthEndpoint(originalUrl);

    if (shouldTryRefresh) {
      originalRequest._retry = true;
      try {
        const token = await refreshSessionToken();
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers["Authorization"] = "Bearer " + token;
        return axios(originalRequest);
      } catch (err) {
        console.error("[AXIOS] refresh token failed", err);
        redirectToLogin();
        return Promise.reject(error);
      }
    }

    if (error.response && error.response.status === 401 && !isAuthEndpoint(originalUrl)) {
      redirectToLogin();
      return Promise.reject(error);
    }

    //check error format
    if (error.response && error.response.data && "success" in error.response.data) {
      notifyApiBusinessError(error.response.data);
      return Promise.reject(error.response.data);
    }

    if (error.response && error.response.data && error.response.data.content && error.response.data.content.success === false) {
      notifyApiBusinessError(error.response.data);
      return Promise.reject(error.response.data);
    }

    return Promise.reject(error);
  }
);
